import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { AUTH_STATE_TOKEN } from '~backoffice/app/~shared/constants/global.constants';
import { BaseAuthComponent } from '../../abstract-components/base-auth.component';
import { ROUTES } from '~backoffice/app/~shared/constants/routes.constants';

@Component({
  selector: 'login-form',
  standalone: false,
  templateUrl: './login-form.component.html',
  styleUrl: './login-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormComponent extends BaseAuthComponent {
  readonly isLoggingIn$ = this._authFacade.isLoggingIn$;
  readonly statePropertyPath = `${AUTH_STATE_TOKEN.getName()}.login.loginFormValues`;

  routes = ROUTES;
  loginForm = new FormGroup({
    username: new FormControl('', {
      validators: [Validators.required, Validators.email],
      nonNullable: true
    }),
    password: new FormControl('', {
      validators: [Validators.required, Validators.minLength(8)],
      nonNullable: true
    })
  });

  onSubmit(): void {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }
    this._authFacade.loginWithPassword();
  }

  get username(): AbstractControl<string | null> | null {
    return this.loginForm.get('username');
  }

  get password(): AbstractControl<string | null> | null {
    return this.loginForm.get('password');
  }
}
